module.exports = __webpack_public_path__ + "static/level-6-logo.e2def01c.png";